module.exports = __webpack_public_path__ + "static/media/pictureNotFound.33ccc07e.png";